import React, { Suspense, useEffect } from "react";
import i18n from "./i18n.ts";
import Routes from "./routes";
import { Spinner } from "react-bootstrap";
import { AuthContextProvider } from "./contexts/AuthContextManagement";
import { useLoading } from "contexts/LoadingContextManagement";
import { FilterContextProvider } from "./contexts/FilterContextManagment";

import {
  LoadingContextProvider,
  LoadingContext,
} from "./contexts/LoadingContextManagement";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/scss/bootstrap.scss";
import "./App.scss";
import "./assets/scss/index.scss";

function App() {
  const { setError, setSuccessMessage } = useLoading();

  useEffect(() => {
    const updateTitle = () => {
      document.title = i18n.t("appTitle");
    };
    updateTitle();
    i18n.on("languageChanged", updateTitle);
    return () => i18n.off("languageChanged", updateTitle);
  }, []);

  const showError = (error) => {
    toast.error(error);
    setError("");
  };
  const showSuccessMessage = (successMessage) => {
    toast.success(successMessage);
    setSuccessMessage("");
  };
  return (
    <FilterContextProvider>
      <AuthContextProvider>
        <LoadingContextProvider>
          <LoadingContext.Consumer>
            {({ loading, error, successMessage }) => (
              <Suspense fallback="">
                <div className="App">
                  <div className={loading ? "app-loader" : "app-loader-hide"}>
                    <Spinner animation="border" variant="primary" />
                  </div>
                  <div>
                    {error !== "" ? showError(error) : null}
                    {successMessage !== ""
                      ? showSuccessMessage(successMessage)
                      : null}
                    <ToastContainer
                      position="top-center"
                      autoClose={3000}
                      hideProgressBar={true}
                    />
                  </div>
                  <Routes />
                </div>
              </Suspense>
            )}
          </LoadingContext.Consumer>
        </LoadingContextProvider>
      </AuthContextProvider>
    </FilterContextProvider>
  );
}

export default App;
